import React from "react";
import { Check } from "lucide-react";
import PropTypes from "prop-types";
import "./TrainingSteps.css";

const TrainingSteps = ({ currentStep, hasSingleHospital = false }) => {
  if (hasSingleHospital) {
    // For users with single hospital, show simplified 2-step process
    return (
      <div className="training-steps-container">
        <div className={`training-step ${currentStep >= 3 ? "completed" : currentStep === 3 ? "active" : ""}`}>
          <div className="training-step-number">
            {currentStep > 3 ? <Check size={16} /> : "2"}
          </div>
          <div className="training-step-text">הוספת שאלות</div>
        </div>
        <div className={`training-step-line ${currentStep >= 3 ? "completed" : ""}`}></div>
        
        <div className={`training-step ${currentStep >= 2 ? "completed" : currentStep === 2 ? "active" : ""}`}>
          <div className="training-step-number">
            {currentStep > 2 ? <Check size={16} /> : "1"}
          </div>
          <div className="training-step-text">בחירת נושא</div>
        </div>
      </div>
    );
  }
  
  // For users with multiple hospitals, show the full 3-step process
  return (
    <div className="training-steps-container">
      <div className={`training-step ${currentStep >= 3 ? "completed" : currentStep === 3 ? "active" : ""}`}>
        <div className="training-step-number">
          {currentStep > 3 ? <Check size={16} /> : "3"}
        </div>
        <div className="training-step-text">הוספת שאלות</div>
      </div>
      <div className={`training-step-line ${currentStep >= 3 ? "completed" : ""}`}></div>
      
      <div className={`training-step ${currentStep >= 2 ? "completed" : currentStep === 2 ? "active" : ""}`}>
        <div className="training-step-number">
          {currentStep > 2 ? <Check size={16} /> : "2"}
        </div>
        <div className="training-step-text">יצירת מבחן</div>
      </div>
      <div className={`training-step-line ${currentStep >= 2 ? "completed" : ""}`}></div>
      
      <div className={`training-step ${currentStep >= 1 ? "completed" : ""}`}>
        <div className="training-step-number">
          {currentStep > 1 ? <Check size={16} /> : "1"}
        </div>
        <div className="training-step-text">בחירת נושא</div>
      </div>
    </div>
  );
};

TrainingSteps.propTypes = {
  currentStep: PropTypes.number.isRequired,
  hasSingleHospital: PropTypes.bool
};

export default TrainingSteps;